import { defaultReactOptions } from 'launchdarkly-react-client-sdk';


/*
To access the feature flags, you need to use the useFlags hook. For example:
import { useFlags } from 'launchdarkly-react-client-sdk';
const { test1 } = useFlags();

if (test1) {
  console.log('test1 is true');
} else {
  console.log('test1 is false');
}

The feature flag already knows the user and the organization because it is defined in the user-info-provider.tsx file.
*/

/**
 * Demo mode feature flag provider that returns true for all flags.
 * Uses a Proxy to intercept any flag access and return true.
 */
const DemoFeatureFlagProvider = ({ children }: { children: React.ReactNode }) => {
  const Context = defaultReactOptions.reactContext;

  const turnedOffFlags = ['isDashboardPageLive'];

  // Proxy that returns true for any flag access
  const allTrueFlags = new Proxy(
    {},
    {
      get: (_target, prop) => {
        // Return true for any flag name
        if (typeof prop === 'string') {
          if (turnedOffFlags.includes(prop)) {
            return false;
          }
          return true;
        }
        return undefined;
      },
      has: () => true,
      ownKeys: () => [],
      getOwnPropertyDescriptor: () => ({
        enumerable: true,
        configurable: true,
      }),
    },
  );

  return (
    <Context.Provider value={{ flags: allTrueFlags, flagKeyMap: {}, ldClient: undefined, error: undefined }}>
      {children}
    </Context.Provider>
  );
};

export const FeatureFlagProvider = ({ children }: { children: React.ReactNode }) => {
  return <DemoFeatureFlagProvider>{children}</DemoFeatureFlagProvider>;
};
